import { Controller } from "@hotwired/stimulus"

// Controller for handling media filter form interactions
export default class extends Controller {
  static targets = ["form"]

  connect() {
    // Initialize debounce timer
    this.submitTimer = null
  }

  disconnect() {
    // Clear any pending timers
    if (this.submitTimer) {
      clearTimeout(this.submitTimer)
    }
  }

  // Submit form immediately (for dropdown changes)
  submit() {
    if (this.hasFormTarget) {
      // Clear any pending debounced submits
      if (this.submitTimer) {
        clearTimeout(this.submitTimer)
      }

      this.formTarget.requestSubmit()
    }
  }

  // Debounced submit for text input
  debounceSubmit(event) {
    // Clear existing timer
    if (this.submitTimer) {
      clearTimeout(this.submitTimer)
    }

    // Set new timer for 500ms
    this.submitTimer = setTimeout(() => {
      this.submit()
    }, 500)
  }

  // Clear all filters and reset form
  clearFilters(event) {
    event.preventDefault()

    if (this.hasFormTarget) {
      // Reset all form inputs
      this.formTarget.reset()

      // Submit the cleared form
      this.submit()
    }
  }

  // Update URL without page reload
  updateUrl(params) {
    const url = new URL(window.location)

    // Update search params
    Object.keys(params).forEach(key => {
      if (params[key]) {
        url.searchParams.set(key, params[key])
      } else {
        url.searchParams.delete(key)
      }
    })

    // Update browser URL without reload
    window.history.replaceState({}, '', url)
  }
}